module.exports = __webpack_public_path__ + "static/img/3bg_4.be847e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_4.png
// module id = 697
// module chunks = 1